import { cssThemedValue } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { Typography } from 'common/typography';

import FirstTimerImage from '../images/FirstTimer.png';
import WebWolt from '../images/WebWolt.png';
import YuhoStamp from '../images/YuhoStamp.png';

const BenefitsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
`;

const BenefitsHeadingContainer = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

const BenefitsListContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  min-height: 350px;
  overflow-x: auto;

  @media (width < 1050px) {
    max-width: 1050px;
  }
`;

const BenefitContainer = styled.div`
  display: flex;
  padding: 20px 20px 30px;
  flex-direction: column;
  align-items: flex-end;
  gap: 30px;
  flex: 1 0 0;
  border-radius: 8px;
  min-height: 464px;
  border: 1px solid ${cssThemedValue('borderPrimary')};
`;

const BenefitImageContainer = styled.div`
  display: flex;
  height: 270px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  background: #00c3ea;
  min-width: 350px;
  border-radius: 8px;
`;

const BenefitsImage = styled.img`
  border-radius: 8px;
  width: 270px;
  height: 270px;
`;

const BenefitTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  text-align: center;
`;

export const Benefits = () => {
  const { formatMessage } = useIntl();
  const benefits = [
    {
      title: formatMessage({ id: 'best-of-wolt.benefits.new-customer.title' }),
      description: formatMessage({ id: 'best-of-wolt.benefits.new-customer.description' }),
      image: FirstTimerImage,
    },
    {
      title: formatMessage({ id: 'best-of-wolt.benefits.recognition.title' }),
      description: formatMessage({ id: 'best-of-wolt.benefits.recognition.description' }),
      image: YuhoStamp,
    },
    {
      title: formatMessage({ id: 'best-of-wolt.benefits.visibility.title' }),
      description: formatMessage({ id: 'best-of-wolt.benefits.visibility.description' }),
      image: WebWolt,
    },
  ];

  return (
    <BenefitsContainer>
      <BenefitsHeadingContainer>
        <Typography.Heading6>
          <FormattedMessage id="best-of-wolt.benefits.title" />
        </Typography.Heading6>
      </BenefitsHeadingContainer>
      <BenefitsListContainer>
        {benefits.map(benefit => (
          <BenefitContainer key={benefit.title}>
            <BenefitImageContainer>
              <BenefitsImage src={benefit.image} alt={benefit.title} />
            </BenefitImageContainer>
            <BenefitTextContainer>
              <Typography.Heading2>{benefit.title}</Typography.Heading2>
              <Typography.Body2>{benefit.description}</Typography.Body2>
            </BenefitTextContainer>
          </BenefitContainer>
        ))}
      </BenefitsListContainer>
    </BenefitsContainer>
  );
};
